// extracted by mini-css-extract-plugin
export default {"button":"EntitySelection_button__gpWpv","buttonText":"EntitySelection_buttonText__6PCHj","title":"EntitySelection_title__3RqNa"};